export default __webpack_public_path__ + "static/media/wildclaw.0cb4a9a9.png";